// ============================================================================
// MOVEMENT RESUMO PANEL
// ARQUIVO: src/features/files/MovementResumoPanel.jsx
// RESPONSABILIDADE: Guardrail de resumo de uma movimentação processual
//   (relatório de arquitetura, Seção 4.4). Nunca escondida a
//   descricaoOficial atrás do resumo; resumo sempre nasce NAO_REVISADO;
//   quem escreve o resumo revisa/corrige aqui.
// ⚠️ ALTERADO em 01/09/2026 (item 5 do PRE_VOO_CADERNO_SINTESE_20260901.md):
//   o botão "Gerar resumo (IA)" (chamava resumirMovimento() -> Gemini direto
//   do navegador) foi REMOVIDO — confirmado em uso real, com resumo já
//   gerado e sentado em produção sem revisão (achado do titular, caso
//   [PET_A]). Nunca foi o caminho certo (Constituição de Processos Art.
//   13.7, 22/08/2026: "o agente lê o TXT e escreve o resumo" — Claude Code
//   em sessão dirigida, nunca um clique de UI chamando API externa). O
//   campo resumo/resumoHistorico[] e o fluxo de revisão continuam intactos
//   — só a geração via botão saiu. Resumos já existentes (inclusive os
//   NAO_REVISADO gerados antes desta mudança) continuam visíveis aqui,
//   revisáveis normalmente.
// Fusão Processos/Caderno (MC11): construção nova — este componente nunca
// chegou a ser commitado na branch pausada (parou no MC07, TimelineItem).
// Depende de MC12 (updateMovementResumo/markMovementResumoReviewed), já
// commitado.
// ============================================================================
import React, { useState } from 'react';
import { markMovementResumoReviewed } from './CadernoCockpitRepository';

const RESUMO_STATUS_BADGE = {
  NAO_REVISADO: { label: 'Resumo não revisado', className: 'bg-yellow-100 text-yellow-800 border-yellow-300' },
  REVISADO_OK: { label: 'Resumo revisado', className: 'bg-green-100 text-green-800 border-green-300' },
  REVISADO_CORRIGIDO: { label: 'Resumo revisado (corrigido)', className: 'bg-blue-100 text-blue-800 border-blue-300' },
};

export const MovementResumoPanel = ({ workspaceId, movementId, descricaoOficial, resumo, currentUserId, onUpdated }) => {
  const [busy, setBusy] = useState(false);

  const handleMarcarRevisado = async (corrigido = false) => {
    setBusy(true);
    try {
      await markMovementResumoReviewed(workspaceId, movementId, currentUserId || 'desconhecido', corrigido);
      onUpdated?.();
    } catch (error) {
      console.error(error);
      alert('Erro ao marcar como revisado: ' + String(error?.message || error));
    } finally {
      setBusy(false);
    }
  };

  const badge = resumo?.status ? RESUMO_STATUS_BADGE[resumo.status] : null;

  return (
    <div className="border border-gray-200 rounded-lg p-3 bg-white space-y-2">
      {/* Guardrail 4.4 item 1: descricaoOficial sempre visível junto do resumo,
          nunca em aba separada que se possa esquecer de abrir. */}
      <p className="text-xs text-gray-600 leading-relaxed bg-gray-50/50 p-2 rounded whitespace-pre-wrap">
        {descricaoOficial}
      </p>

      {resumo?.texto && (
        <div className="p-2 rounded border border-dashed border-gray-300 bg-blue-50/30">
          <div className="flex items-center justify-between mb-1">
            <span className="text-[9px] font-bold text-gray-500 uppercase">
              <i className="fas fa-robot mr-1"></i>Resumo ({resumo.geradoPor === 'IA' ? 'IA' : 'Humano'})
            </span>
            {badge && <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded border ${badge.className}`}>{badge.label}</span>}
          </div>
          <p className="text-xs text-gray-700 leading-relaxed">{resumo.texto}</p>
        </div>
      )}

      <div className="flex gap-2 flex-wrap">
        {resumo?.status === 'NAO_REVISADO' && (
          <>
            <button
              onClick={() => handleMarcarRevisado(false)}
              disabled={busy}
              className="text-[10px] font-bold uppercase px-2 py-1 rounded bg-green-600 text-white hover:bg-green-700 disabled:opacity-50"
            >
              Marcar como revisado
            </button>
            <button
              onClick={() => handleMarcarRevisado(true)}
              disabled={busy}
              className="text-[10px] font-bold uppercase px-2 py-1 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
            >
              Revisado (corrigi)
            </button>
          </>
        )}
      </div>
    </div>
  );
};
